// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32UJV","rootMobile":"styles_rootMobile__3yZOE"};